export default {
    en: {
        locale: 'en_EN',
        routes: {
            about: "about-us",
            steelKeg: "packaging",
            keyKeg: "keykeg",
            collection: "the-collection",
            be_smart: "be-smart",
            contact: "contact",
            privacy: "privacy-policy",
            cookie: "cookies-policy",
            wines: {
                white: 'white-wines',
                red: 'red-wines',
                sparkling: 'sparkling-wines'
            }
        },
        menu: {
            about: "About Us",
            package: "Package",
            steelKeg: "Steel Keg",
            keyKeg: "KeyKeg",
            collection: "The Collection",
            be_smart: "Be Smart",
            contact: "Contact",
            privacy: "Privacy Policy",
            cookie: "Cookies Policy",
            wines: {
                white: 'White Wines',
                red: 'Red Wines',
                sparkling: 'Sparkling Wines'
            },
            newsletter: "Subscribe to our newsletter"
        },
        disclaimer: {
            title: 'Please insert your location and your date of birth',
            content: 'We must confirm that you are of legal drinking age in your location before welcoming you to MonVin. If there is no legal age for consuming alcohol in your location, you must be over 21.',
            notification: "You do not have the minimum age required by law, unfortunately we can not welcome you on our site.",
            form: {
                location: 'Location',
                birthdate: 'Birthdate',
                submit: 'Submit',
                select: 'Select your Location'
            },
            footer: {
                1: "The abuse of alcohol is dangerous for your health",
                2: "Drink responsibly",
                3: "By entering this site you acknowledge that you accept its Terms & Conditions of Use and have read its Privacy & Cookies Notice."
            }
        },
        collections: {
            alcohol: 'Alcohol 0% vol',
            acidity: 'Total acidity &permil;tot. Ac.',
            sugar: 'Sugar content %',
            so2: 'Tot. So2 mg/l',
            pressure: "Pressure at./",
            cta: "Contact us",
            downloads: "Download PDF"
        },
        homepage: {
            section1: {
                title: "The finest Italian wine on tap.",
                content: "MonVin has always considered the drinking of wine on tap as a joyous and convivial moment, a typical expression of the Italian lifestyle."
            },
            section2: {
                title: "A new way of drinking",
                content: "MonVin promotes responsible consumption, with the aim of introducing more people to a world made of culture and positive values.",
                cta: "Discover our positive values",
                advantages: {
                    1: "Reduces waste",
                    2: "Eco-friendly",
                    3: "Eco-sustainable",
                    4: "Reduces CO<sub>2</sub> emissions"
                }
            },
            section3: {
                title: 'Smart Business',
                subtitle: "Your restaurant and bars can turn to tap!",
                content: "A better and convenient way<br>to serve wine in your business.",
                cta: "Discover why it is smart",
                advantages: {
                    1: "Very high quality",
                    2: "Maximum storage duration",
                    3: "No expensive returns",
                    4: "Simply plug in using compressed air"
                }
            },
            section4: {
                title: "The territory: the heart of Veneto",
                caption: "In this picture Serena's Family: Sarah, Alberto and Armando.",
                content: "MonVin is situated in Volpago (TV), one of the best areas in the wine-growing hills of Treviso, renowned throughout the whole world for the quality of its wines.",
                cta: "Discover our History"
            },
            section5: {
                title: "The quality of Italian wine",
                content: "MonVin is the undisputed leader in the production of quality wines on tap. It represents the authentic pleasure of typical Italian wine that the restaurateur chooses with care, guaranteeing its quality."
            }
        },
        collectionRouter: {
            cta: "Discover the collection",
            white: "White Wines",
            red: "Red Wines",
            sparkling: "Sparkling Wines"
        },
        slider: {
            slide1: {
                title: "From vine to wine",
                content: "The best Italian wine on Tap"
            },
            slide2: {
                title: "A new way of sharing",
                content: "Why people choose wine on tap"
            },
            slide3: {
                title: "A conscious and fresh choice",
                content: "Quality and Eco-sustainability"
            },
        },
        about: {
            section1: {
                title: "We are MonVin",
                paragraphs: {
                    1: "MonVin is situated in Volpago (TV), one of the best areas in the wine-growing hills of Treviso, renowned throughout the whole world for the quality of its wines.",
                    2: "It all began thanks to the intuition of Armando Serena, member of a family involved in winemaking since 1881, who founded the company in 1968, in an area near Venice that is, in terms of culture and nature, one of the most interesting in all of Italy.",
                    3: "MonVin believes in the Veneto wine-growing system that combines prestigious vines with vast autochthonous production knowledge, allowing unique sensorial experiences."
                }
            },
            section2: {
                title: "The quality of Italian wine",
                paragraphs: {
                    1: "MonVin is the undisputed leader in the production of quality wines on tap. It represents the authentic pleasure of typical Italian wine that the restaurateur chooses with care, guaranteeing its quality.",
                    2: "MonVin’s valuable experience in the world of wine on tap allows it to constantly improve the quality of its products, and to select from a wide range of wines.",
                    3: "MonVin promotes responsible consumption, with the aim of introducing more people to a world made of culture and positive values."
                }
            }
        },
        collection: {
            navigationTitle: 'Choose your preferred package.',
            steel: 'Steel Keg',
            keykeg: 'Keykeg',
            availableWorldwide: 'Our collection available worldwide',
            availableItaly: 'Our collection available only in Italy and Japan'
        },
        beSmart: {
            title: "A conscious choice",
            section1: {
                title: "Supply chain traceability",
                advantage1: {
                    text: "Milion Litres",
                    content: "MonVin has implemented a traceability project that makes it possible to retrace all the production stages of our wine: from your glass right back to the wine-making process."
                },
                advantage2: {
                    text: "Oenologists",
                    content: "Our technical staff, composed of six oenologists, constantly follow each phase of the production and keglling process. "
                },
                advantage3: {
                    text: "Milion Euros invested in technology",
                    content: "Over the last 10 years, MonVin has invested 10 million euros in technological innovation, and the company boasts important patents in the oenological sector."
                },
            },
            section2: {
                title: "Wine on tap<br>«Be Smart, Drink MonVin»",
                paragraphs: {
                    1: "Drinking wine on tap is “smart” and eco-friendly, because it does not involve the use of bottles or packaging. ",
                    2: "MonVin ushers in a new era in the winemaking  field, promoting wine-on-tap tasting and a modern, sustainable consumption model.",
                    3: "A conscious choice: wine on tap makes it possible to optimize production processes, to use less energy and fewer environmental resources and to reduce waste and atmospheric pollution.",
                    4: "MonVin’s focus on environmental issues also provides significant  financial savings, without having to compromise on the pleasure of enjoying a quality wine."
                },
                advantages: {
                    1: "Reduces waste",
                    2: "Eco-friendly",
                    3: "Eco-sustainable",
                    4: "Reduces CO2 emissions"
                }
            },
            section3: {
                title: "100% Clean Energy",
                text: "We only use"
            }
        },
        contact: {
            title: 'Contacts',
            form: {
                title: 'Get in touch',
                firstName: 'First Name',
                lastName: 'Last Name',
                email: 'Email',
                message: 'Message',
                privacyPolicy: 'I have read and agree to',
                errors: {
                    empty: 'Questo campo è obligatorio',
                    email: 'Questo campo deve contenere una mail valida.',
                    policy: 'Error'
                },
                feedback: {
                    title: 'Thank you!',
                    message: 'Thank you for your message, we have received it and will get back to you as soon as possible.'
                },
                cta: "Submit",
                subscribe: "Subscribe"
            }
        },
        seo: {
            homepage: {
                title: 'The finest Italian wine on tap.',
                description: 'MonVin has always considered the drinking of wine on tap as a joyous and convivial moment, a typical expression of the Italian lifestyle.'
            },
            about: {
                title: "We are MonVin",
                description: "MonVin believes in the Veneto wine-growing system that combines prestigious vines with vast autochthonous production knowledge, allowing unique sensorial experiences."
            },
            keykeg: {
                title: "Keykeg, quality and guarantee",
                description: "MonVin uses the KeyKeg technology developed by LWC, the environmentally friendly single-use keg produced using over 50% recycled PET."
            },
            keg: {
                title: "Acciaio: qualità e garanzia",
                description: "Il fusto MonVin è ergonomico, facile da trasportare e da accatastare, occupa poco spazio e grazie al suo inconfondibile rivestimento nero, evita al vino di subire shock termici, ai quali sono invece sottoposti i fusti ricoperti solo d’acciaio."
            },
            collection: {
                title: "The MonVin Collection",
                description: "The MonVin collection of White, Red, Rosè and sparkling Wines"
            },
            "white-wines": {
                title: "White Wines",
                description: "The MonVin collection of White Wines. Chardonnay. Pinot Grigio IGT."
            },
            "red-wines": {
                title: "Red Wines",
                description: "The MonVin collection of Red and Rosè Wines. Merlot. Sangiovese IGT. Merlot Cabernet. Regandino."
            },
            "sparkling-wines": {
                title: "Sparkling Wines",
                description: "The MonVin collection of White, Red and Rosè sparkling Wines. Prodry. Alzaia. Regandino Frizzante."
            },
            beSmart: {
                title: "Be Smart - A conscious choice",
                description: "Drinking wine on tap is “smart” and eco-friendly, because it does not involve the use of bottles or packaging."
            },
            contact: {
                title: "Contacts",
                description: "MonVin di Montelvini SRL. Get in touch!"
            }
        },
        package: {
            title: 'Keykeg, quality and guarantee',
            section1: {
                paragraphs: {
                    1: 'MonVin uses the KeyKeg technology developed by LWC, the environmentally friendly single-use keg produced using over 50% recycled PET.',
                    2: 'The patented Bag-in-Keg principle is based on a special internal, laminated aluminium bag, contained in a high-tech PET package. This two-compartment system preserves the quality of the wine and its shelf life offering key optimal protection from exposure to air, and the wine never comes into contact with the gases.',
                    3: 'The convenient format and practical grip allows anyone to use KeyKeg straight away. The kegs are light and easy to stack: this system saves space in the warehouse and transportation.',
                    4: 'Also available in',
                    5: 'Weight: 20 Lt, KeyKeg: 20 KG > Corresponding to 27 bottles of 0,75 litres.'
                }
            },
            advantages: {
                1: 'Very high quality',
                2: 'Suitable for still and sparkling wines and maximum storage duration',
                3: 'Suitable for most filling systems',
                4: 'No expensive returns',
                5: 'No loss of barrels or cleaning costs, simply plug in using compressed air',
                6: 'For some wines, the PolyKeg model is also available.'
            },
            section2: {
                title: 'Advantages',
                paragraphs: {
                    1: 'The light kegs used by MonVin are recyclable.',
                    2: 'All of the raw materials can be separated in just a few stages and used to produce new SlimKegs.',
                    3: 'The basic parts of the barrels are already made of 100% recycled plastic.'
                }
            },
            section3: {
                paragraphs: {
                    1: 'The environmental benefits don’t stop there. The compact design means a 25-30% greater load capacity.',
                    2: 'Transport savings can be up to 65%; this reduces CO2 emissions which are further reduced if compressed air is used for tapping.',
                    3: 'The SlimKeg system is completely in line with the objectives of sustainability, but at lower cost, and without compromising quality.'
                },
                advantages: {
                    1: 'No more-lifting bottles.',
                    2: 'No more pre-refigeration of bottles.',
                    3: 'No more opening single bottles.',
                    4: 'No more bottles to dispose of.'
                }
            }
        },
        steelkeg: {
            title: "Acciaio: qualità e garanzia",
            section1: {
                paragraphs: {
                    1: "L’acciaio del fusto è il materiale che meglio di tutti gli altri conserva il vino, in quanto non viene a contatto con la luce e soprattutto con l’aria: sembra di bere sempre una bottiglia appena stappata.",
                    2: "Il fusto si può riutilizzare, grazie alla tecnologia che lo sterilizza prima di ogni nuovo riempimento: in questo modo si hanno sempre vini sicuri e garantiti dal punto di vista organolettico.",
                    3: "Il fusto MonVin è ergonomico, facile da trasportare e da accatastare, occupa poco spazio e grazie al suo inconfondibile rivestimento nero, evita al vino di subire shock termici, ai quali sono invece sottoposti i fusti ricoperti solo d’acciaio.",
                    4: "Peso: 20Lt, corrisponde a 20 bottiglie"
                }
            },
            advantages: {
                1: "Mantiene inalterato il vino e le sue proprietà",
                2: "Di facile installazione",
                3: "Nero lucido con possibile personalizzazione",
                4: "Nessun costo di manutenzione",
                5: "Ergonomico facile da trasportare e accatastare",
                6: "Riutilizzabile: veloce da sterilizzare",
            },
            section2: {
                title: "Vantaggi",
                advantages: {
                    1: "Nessun problema di maneggevolezza delle bottiglie.",
                    2: "Nessuna prerefrigerazione richiesta.",
                    3: "Nessuna apertura delle bottiglie necessaria.",
                    4: "Nessuna bottiglia residua."
                }
            }
        }
    },
    it: {
        locale: 'it_IT',
        seo: {
            homepage: {
                title: "L’eccellenza del vino alla spina Made in Italy",
                description: "MonVin considera da sempre il consumo del vino alla spina un momento conviviale di gioia e amicizia, espressione dello stile di vita unico italiano."
            },
            about: {
                title: "Noi siamo MonVin",
                description: "MonVin crede nel modello vitivinicolo veneto che sposa vitigni di pregio alla sapienza produttiva autoctona, permettendo esperienze sensoriali uniche."
            },
            keykeg: {
                title: "Keykeg, quality and guarantee",
                description: "MonVin uses the KeyKeg technology developed by LWC, the environmentally friendly single-use keg produced using over 50% recycled PET."
            },
            keg: {
                title: "Acciaio: qualità e garanzia",
                description: "Il fusto MonVin è ergonomico, facile da trasportare e da accatastare, occupa poco spazio e grazie al suo inconfondibile rivestimento nero, evita al vino di subire shock termici, ai quali sono invece sottoposti i fusti ricoperti solo d’acciaio."
            },
            collection: {
                title: "La collezione MonVin",
                description: "La collezione MonVin di Vini Bianchi, Rossi, Rosè e Vini Frizzanti."
            },
            "vini-bianchi": {
                title: "Vini Bianchi",
                description: "La collezione MonVin di Vini Bianchi. Chardonnay. Verduzzo IGT. Verd'oro. Bianco dei Dogi. Sauvignon."
            },
            "vini-rossi": {
                title: "Vini Rossi",
                description: "La collezione MonVin di Vini Rossi e Rosè. Rosso dei Dogi. Merlot. Monvin Rosso. Sangiovese IGT. Cabernet. Malbech. Regandino Fermo."
            },
            "vini-frizzanti": {
                title: "Vini Frizzanti",
                description: "La collezione MonVin di Vini frizzanti Bianchi, Rossi e Rosè. Verd'oro Vivo. Prodry. Alzaia. Giramondo. Raboso IGT. Raborosa. Regandino Frizzante."
            },
            beSmart: {
                title: "Be Smart - Una scelta consapevole",
                description: "Bere vino alla spina significa essere «smart», sensibili ai temi ambientali, perché non si utilizzano bottiglie e packaging."
            },
            contact: {
                title: "Contatti",
                description: "MonVin di Montelvini SRL. Scrivici!"
            }
        },
        routes: {
            about: "chi-siamo",
            steelKeg: "confezione",
            keyKeg: "keykeg",
            collection: "la-collezione",
            be_smart: "be-smart",
            contact: "contatti",
            privacy: "privacy-policy",
            cookie: "cookies-policy",
            wines: {
                white: 'vini-bianchi',
                red: 'vini-rossi',
                sparkling: 'vini-frizzanti'
            }
        },
        menu: {
            about: "Chi Siamo",
            package: "Package",
            steelKeg: "Fusto Acciaio",
            keyKeg: "Keykeg",
            collection: "La collezione",
            be_smart: "Be Smart",
            contact: "Contatti",
            privacy: "Privacy Policy",
            cookie: "Cookies Policy",
            wines: {
                white: 'Vini bianchi',
                red: 'Vini Rossi',
                sparkling: 'Vini Frizzanti'
            },
            newsletter: "Iscriviti alla newsletter"
        },
        disclaimer: {
            title: 'Si prega di inserire luogo di residenza e data di nascita',
            content: "Per accedere al sito MonVin, è necessario avere l’età legale per il consumo di alcolici prevista nel luogo di residenza.<br>In mancanza di una normativa in materia, l’età minima per visitare questo sito è 21 anni.",
            notification: "Non hai l'eta minima prevista dalla legge, purtroppo non possiamo darti il benvenuto sul nostro sito.",
            form: {
                location: 'Luogo di Residenza',
                birthdate: 'Data di nascita',
                submit: 'Accedi',
                select: 'Seleziona il luogo'
            },
            footer: {
                1: "Disclaimer: L'abuso di Alcol nuoce alla salute",
                2: "Bevi in modo responsabile",
                3: "L’accesso al sito comporta l’accettazione delle note legali e dell’informativa in materia di privacy e cookie."
            }
        },
        collections: {
            alcohol: 'Alcool % vol.',
            acidity: 'Acidità tot &permil; ac.Tart.',
            sugar: 'Contenuto % zuccheri',
            so2: 'So2 tot. mg./lt.',
            pressure: "Pressione atm.",
            cta: "Contattaci",
            downloads: "Scarica PDF"
        },
        homepage: {
            section1: {
                title: "L’eccellenza<br class='mobile-break'> del vino alla spina<br>Made in Italy.",
                content: "MonVin considera da sempre il consumo del vino alla spina un momento conviviale di gioia e amicizia, espressione dello stile di vita unico italiano."
            },
            section2: {
                title: "Un nuovo modo<br class='mobile-break'> di bere",
                content: "MonVin promuove il consumo responsabile, con l’obiettivo di avvicinare sempre più persone ad un universo fatto di cultura e valori positivi.",
                cta: "Scopri i nostri valori positivi",
                advantages: {
                    1: "Riduce i rifiuti",
                    2: "Eco-friendly",
                    3: "Ecosostenibile",
                    4: "Riduce le emissioni<br class='mobile-break'> di CO<sub>2</sub>"
                }
            },
            section3: {
                title: 'Fai diventare smart il tuo locale',
                subtitle: "Scopri perchè ristoranti e bar scelgono il vino alla spina",
                content: "Un modo migliore e più conveniente per servire il vino nella tua attività.",
                cta: "Scopri i vantaggi",
                advantages: {
                    1: "Altissima qualità",
                    2: "Ampio periodo di stoccaggio",
                    3: "Nessun costo di manutenzione",
                    4: "Di facile installazione"
                }
            },
            section4: {
                title: "Il territorio: il cuore del Veneto",
                caption: "La famiglia Serena: Sarah, Alberto e Armando Serena.",
                content: "MonVin si trova a Volpago (TV), nella zona DOCG Montello e Colli Asolani, conosciuta in tutto il mondo per la qualità dei suoi vini.",
                cta: "Scopri la nostra storia"
            },
            section5: {
                title: "La qualità del vino italiano",
                content: "MonVin è oggi il leader indiscusso nella produzione del vino alla spina di qualità e rappresenta quel piacere autentico del “vino della casa” che il ristoratore seleziona con cura, garantendone la genuinità."
            }
        },
        collectionRouter: {
            cta: "Scopri la collezione",
            white: "Vini Bianchi",
            red: "Vini Rossi",
            sparkling: "Vini Frizzanti"
        },
        slider: {
            slide1: {
                title: "Dalla vigna al vino",
                content: "Il miglior vino italiano alla spina"
            },
            slide2: {
                title: "Un nuovo modo di condividere",
                content: "Perchè tutti scelgono il vino alla spina"
            },
            slide3: {
                title: "Una scelta fresca e consapevole",
                content: "Qualità è sinonimo di sostenibilità"
            },
        },
        about: {
            section1: {
                title: "Noi siamo MonVin",
                paragraphs: {
                    1: "MonVin si trova a Volpago (TV), nella zona DOCG Montello e Colli Asolani, conosciuta in tutto il mondo per la qualità dei suoi vini.",
                    2: "Nasce da un’intuizione di Armando Serena, erede di una dinastia presente nel mondo del vino dal 1881. Nel 1968 ha fondato l’attuale azienda in un territorio dal punto di vista naturalistico e culturale tra i più interessanti del Veneto, a due passi da Venezia.",
                    3: "MonVin crede nel modello vitivinicolo veneto che sposa vitigni di pregio alla sapienza produttiva autoctona, permettendo esperienze sensoriali uniche."
                }
            },
            section2: {
                title: "La qualità del vino italiano",
                paragraphs: {
                    1: "MonVin è oggi il leader indiscusso nella produzione del vino alla spina di qualità e rappresenta quel piacere autentico del “vino della casa” che il ristoratore seleziona con cura, garantendone la genuinità.",
                    2: "La grande esperienza maturata nel mondo del vino alla spina, ha permesso a MonVin di migliorare costantemente la qualità dei prodotti e selezionare un’ampia gamma di vini.",
                    3: "MonVin promuove il consumo responsabile, con l’obiettivo di avvicinare sempre più persone ad un universo fatto di cultura e valori positivi."
                }
            }
        },
        collection: {
            navigationTitle: 'Scegli il tipo di package che preferisci',
            steel: 'Fusto Acciaio',
            keykeg: 'Keykeg',
            availableWorldwide: 'La nostra collezione disponibile in tutto il mondo',
            availableItaly: 'La nostra collezione disponibile solo in Italia e Giappone'
        },
        beSmart: {
            title: "Una scelta consapevole",
            section1: {
                title: "La tracciabilità della filiera",
                advantage1: {
                    text: "milioni di litri",
                    content: "MonVin ha messo a punto un severo progetto di tracciabilità che permette di ripercorrere a ritroso tutto il percorso produttivo del vino: dal bicchiere fino alla sua vinificazione."
                },
                advantage2: {
                    text: "enologi",
                    content: "Uno staff tecnico composto da sei enologi segue costantemente ogni fase di produzione e riempimento."
                },
                advantage3: {
                    text: "milioni di euro investiti in tecnologia",
                    content: "In oltre dieci anni MonVin ha investito dieci milioni di euro in innovazione tecnologica: l’azienda vanta importanti brevetti nel settore enologico."
                },
            },
            section2: {
                title: "Vino alla spina<br>«Be Smart, Drink MonVin»",
                paragraphs: {
                    1: "Bere vino alla spina significa essere «smart», sensibili ai temi ambientali, perché non si utilizzano bottiglie e packaging.",
                    2: "MonVin inaugura così una nuova frontiera in ambito enologico promuovendo una degustazione di vini e un consumo più sostenibile.",
                    3: "Una scelta consapevole, il vino alla spina permette di limitare i costi di produzione, di consumare meno risorse energetiche ed ambientali, di creare meno rifiuti ed inquinamento atmosferico.",
                    4: "Tutto ciò racconta l’attenzione per l’ambiente di MonVin: il fusto garantisce un notevole risparmio economico senza dover rinunciare al piacere di bere un vino di qualità."
                },
                advantages: {
                    1: "Riduce i rifiuti",
                    2: "Eco-friendly",
                    3: "Ecosostenibile",
                    4: "Riduce le emissioni di CO2"
                }
            },
            section3: {
                title: "100% Energia Pulita",
                text: "Utilizziamo solo"
            }
        },
        contact: {
            title: 'Contatti',
            form: {
                title: 'Scrivici',
                firstName: 'Nome',
                lastName: 'Cognome',
                email: 'E-Mail',
                message: 'Messaggio',
                privacyPolicy: "Acconsento al trattamento dei miei dati come specificato nella ",
                errors: {
                    empty: 'Questo campo è obligatorio',
                    email: 'Questo campo deve contenere una mail valida.',
                    policy: 'Per poter continuare è necessario accettare la privacy policy'
                },
                feedback: {
                    title: 'Grazie!',
                    message: "Grazie per il tuo messaggio, lo abbiamo ricevuto e ti risponderemo il prima possibile."
                },
                cta: "Invia",
                subscribe: "Iscriviti"
            }
        },
        package: {
            title: 'Keykeg: qualità e garanzia',
            section1: {
                paragraphs: {
                    1: "MonVin utilizza la tecnologia sviluppata da «SlimKeg» il fusto monouso amico dell’ambiente, prodotto con oltre il 50% di PET riciclato.",
                    2: "Il principio brevettato Bag-in-Ball si fonda su una speciale sacca interna il alluminio laminato contenuta in un contenitore in PET high-tech. Questo sistema a due scomparti preserva la qualità e la durata delle bevande negli SlimKeg. I fusti offrono la protezione ottimale dall'esposizione all'aria e le bevande non vengono mai a contatto con i gas, prolungando ulteriormente la loro durata.",
                    3: 'Il comodo formato e la pratica impugnatura permettono a chiunque di utilizzare immediatamente gli SlimKeg. I fusti sono leggeri e facili da impilare: il sistema SlimKeg fa risparmiare spazio in magazzino e durante il trasporto.',
                    4: 'Per alcuni vini disponibile anche il modello ',
                    5: 'Peso: 20 Lt, Fusto: 20 KG > Corrisponde a 27 bottiglie da 0,75 litri.'
                }
            },
            advantages: {
                1: 'Elevatissima qualità',
                2: 'Adatto a vini fermi e frizzanti e massima durata di stoccaggio',
                3: 'Adatto alla maggior parte dei sistemi di riempimento',
                4: 'Nessun costoso viaggio per i resi',
                5: "Nessuna perdita di fusti o costi di pulizia, Si spina usando l'aria compressa",
                6: 'Per alcuni vini disponibile anche il modello PoliKEG'
            },
            section2: {
                title: 'I vantaggi',
                paragraphs: {
                    1: 'I leggeri fusti utilizzati da MonVin sono riciclabili.',
                    2: 'Tutti i materiali grezzi possono essere separati con pochi passaggi e utilizzati per produrre nuovi SlimKeg.',
                    3: 'Gli elementi fondamentali dei fusti sono già prodotti con plastica riciclata al 100%.'
                }
            },
            section3: {
                paragraphs: {
                    1: "Ma i vantaggi per l'ambiente non si fermano qui. Il design compatto significa una maggiore capacità di carico del 25-30% rispetto ai fusti in acciaio.",
                    2: "Sono necessarie meno spedizioni e viene annullato il concetto di restituzione. Il risparmio sul trasporto può arrivare al 65%; si riducono così le emissioni di CO2 che vengono ulteriormente ridotte se si impiega l'aria compressa per la spillatura. Niente più agenti chimici nocivi per la pulizia del fusti in acciaio.",
                    3: "Il sistema SlimKeg è totalmente in linea con gli obiettivi di sostenibilità di molte aziende, ma a costo inferiore e senza compromettere la qualità."
                },
                advantages: {
                    1: 'Mai più sollevare pesanti casse di bottiglie',
                    2: 'Mai più prerefrigerazione di bottiglie',
                    3: 'Mai più apertura di bottiglie singole',
                    4: 'Ma più bottiglie da smaltire.'
                }
            }
        },
        steelkeg: {
            title: "Acciaio: qualità e garanzia",
            section1: {
                paragraphs: {
                    1: "L’acciaio del fusto è il materiale che meglio di tutti gli altri conserva il vino, in quanto non viene a contatto con la luce e soprattutto con l’aria: sembra di bere sempre una bottiglia appena stappata.",
                    2: "Il fusto si può riutilizzare, grazie alla tecnologia che lo sterilizza prima di ogni nuovo riempimento: in questo modo si hanno sempre vini sicuri e garantiti dal punto di vista organolettico.",
                    3: "Il fusto MonVin è ergonomico, facile da trasportare e da accatastare, occupa poco spazio e grazie al suo inconfondibile rivestimento nero, evita al vino di subire shock termici, ai quali sono invece sottoposti i fusti ricoperti solo d’acciaio.",
                    4: "Peso: 20Lt, corrisponde a 20 bottiglie"
                }
            },
            advantages: {
                1: "Mantiene inalterato il vino e le sue proprietà",
                2: "Di facile installazione",
                3: "Nero lucido con possibile personalizzazione",
                4: "Nessun costo di manutenzione",
                5: "Ergonomico facile da trasportare e accatastare",
                6: "Riutilizzabile: veloce da sterilizzare",
            },
            section2: {
                title: "Vantaggi",
                advantages: {
                    1: "Nessun problema di maneggevolezza delle bottiglie.",
                    2: "Nessuna prerefrigerazione richiesta.",
                    3: "Nessuna apertura delle bottiglie necessaria.",
                    4: "Nessuna bottiglia residua."
                }
            }
        }
    },
    ja: {
        locale: 'ja_JP',
        seo: {
            homepage: {
                title: "メイド・イン・イタリーの卓越した樽詰めワイン",
                description: "MonVinは常々、樽詰めワインを飲みながら友人たちと過ごす喜びのひと時を、イタリア独特のライフスタイルの表現だと考えています。"
            },
            about: {
                title: "私たちがMonVinです",
                description: "MonVinは、価値あるブドウと土着の生産の知恵を結びつけることで、ユニークな感覚体験を可能にするヴェネト州のワイン造り様式を信じています。"
            },
            keykeg: {
                title: "Keykeg、品質と保証",
                description: "MonVinは、LWCによって開発されたKeyKeg技術を使用しています。これはリサイクルPETを50%以上使用して製造された環境に優しい使い捨て樽です。"
            },
            keg: {
                title: "スチール：品質と保証",
                description: "MonVinの樽は人間工学に基づいて設計されており、運搬や積み替えが容易な上に、スペースをほとんど取りません。また独特な黒いコーティングがワインを熱衝撃から守り、代わりにスチールのみで覆われた樽が熱衝撃を吸収します。"
            },
            collection: {
                title: "MonVinコレクション",
                description: "MonVinコレクションの白、赤、ロゼ、スパークリングワイン。"
            },
            "white-wines": {
                title: "白ワイン",
                description: "MonVinコレクションの白ワイン。シャルドネ。ヴェルドゥッツォIGT。ヴェルドーロ。ビアンコ・デイ・ドージ。ソーヴィニヨン。"
            },
            "red-wines": {
                title: "赤ワイン",
                description: "MonVinコレクションの赤ワインとロゼ。ロッソ・デイ・ドージ。メルロー。モンヴィン・ロッソ。サンジョヴェーゼIGT。カベルネ。マルベック。レガンディーノ・スティル。"
            },
            "sparkling-wines": {
                title: "スパークリングワイン",
                description: "MonVinコレクションの白、赤、ロゼのスパークリングワイン。ヴェルドーロ・ヴィヴォ。プロドライ。アルツァイア。ジラモンド。ラボーゾIGT。ラボローザ。レガンディーノ・スパークリング。"
            },
            beSmart: {
                title: "スマートに - 意識的な選択",
                description: "樽詰めワインを飲むということは、環境問題に敏感な「スマートさ」を意味します。なぜなら、ボトルやパッケージを使用しないからです。"
            },
            contact: {
                title: "お問い合わせ",
                description: "Montelvini SRLのMonVin。お問い合わせください！"
            }
        },
        routes: {
            about: "about-us",
            steelKeg: "packaging",
            keyKeg: "keykeg",
            collection: "the-collection",
            be_smart: "be-smart",
            contact: "contact",
            privacy: "privacy-policy",
            cookie: "cookies-policy",
            wines: {
                white: 'white-wines',
                red: 'red-wines',
                sparkling: 'sparkling-wines'
            }
        },
        menu: {
            about: "当社について",
            package: "パッケージ",
            steelKeg: "スチール樽",
            keyKeg: "Keykeg",
            collection: "コレクション",
            be_smart: "スマートに",
            contact: "お問い合わせ",
            privacy: "プライバシー ポリシー",
            cookie: "Cookieポリシー",
            wines: {
                white: '白ワイン',
                red: '赤ワイン',
                sparkling: 'スパークリングワイン'
            },
            newsletter: "Subscribe to our newsletter"
        },
        disclaimer: {
            title: '居住地と生年月日を入力してください',
            content: "MonVinサイトにアクセスするには、居住地の法律で飲酒が認められた年齢に達している必要があります。該当する規定がない場合、本サイトの閲覧が認められるのは21歳以上です。",
            notification: "法律で定められた年齢に達していないため、あいにく本サイトをご覧いただけません。",
            form: {
                location: '居住地',
                birthdate: '生年月日',
                submit: '閲覧する',
                select: '場所を選択'
            },
            footer: {
                1: "免責事項：アルコールを乱用すると健康を損ないます",
                2: "責任ある飲酒を行いましょう",
                3: "本サイトへアクセスすることにより、プライバシーとCookieに関する法的通知および情報に同意したものとみなされます。"
            }
        },
        collections: {
            alcohol: 'アルコール度数',
            acidity: '総酸度',
            sugar: '含有糖度',
            so2: '亜硫酸塩量（mg/リットル）',
            pressure: "気圧",
            cta: "お問い合わせ",
            downloads: "PDFをダウンロード"
        },
        homepage: {
            section1: {
                title: "メイド・イン・イタリーの卓越した樽詰めワイン",
                content: "MonVinは常々、樽詰めワインを飲みながら友人たちと過ごす喜びのひと時を、イタリア独特のライフスタイルの表現だと考えています。"
            },
            section2: {
                title: "新しい飲み方",
                content: "MonVinは、より多くの人々を文化的かつ肯定的な価値観の世界に導くことを目指して、責任ある飲酒を促進しています。",
                cta: "肯定的な価値観の詳細を見る",
                advantages: {
                    1: "ごみの削減",
                    2: "エコフレンドリー",
                    3: "環境に優しい",
                    4: "CO<sub>2</sub>排出量の削減"
                }
            },
            section3: {
                title: 'お客様のお店をスマートに',
                subtitle: "レストランやバーが樽詰めワインを選ぶ理由をご覧ください",
                content: "お店でワインを提供するためのより良く、より有利な方法。",
                cta: "メリットを見る",
                advantages: {
                    1: "最高の品質",
                    2: "保存期間の長さ",
                    3: "メンテナンス費用なし",
                    4: "設置が簡単"
                }
            },
            section4: {
                title: "土地：ヴェネト州の中心",
                caption: "セレーナ家の面々：サラ、アルベルト、アルマンド・セレーナ",
                content: "MonVinは、ワインの品質で世界中にその名を知られるDOCGモンテッロ・エ・コッリ・アゾラーニ地域のヴォルパーゴ（トレヴィーゾ）に位置しています。",
                cta: "当社の歴史を見る"
            },
            section5: {
                title: "イタリアワインの品質",
                content: "MonVinは現在、質の高い樽詰めワインの製造において万人が認めるリーダーであり、レストランが厳選した「ハウスワイン」に本物の価値を保証することで、その真の喜びを体現しています。"
            }
        },
        collectionRouter: {
            cta: "コレクションを見る",
            white: "白ワイン",
            red: "赤ワイン",
            sparkling: "スパークリングワイン"
        },
        slider: {
            slide1: {
                title: "ブドウ畑からワインまで",
                content: "最高のイタリア製樽詰めワイン"
            },
            slide2: {
                title: "新しい分かち合いの形",
                content: "誰もが樽詰めワインを選ぶ理由"
            },
            slide3: {
                title: "フレッシュで意識的な選択",
                content: "品質と持続可能性が意味するものは同じです"
            },
        },
        about: {
            section1: {
                title: "私たちがMonVinです",
                paragraphs: {
                    1: "MonVinは、ワインの品質で世界中にその名を知られるDOCGモンテッロ・エ・コッリ・アゾラーニ地域のヴォルパーゴ（トレヴィーゾ）に位置しています。",
                    2: "1881年以来ワインの世界に君臨してきた家系に生まれたアルマンド・セレーナの直感から誕生しました。アルマンドは1968年、ヴェネツィアにほど近い、自然と文化的な観点からヴェネト州でも最も興味深い土地に現在の会社を設立しました。",
                    3: "MonVinは、価値あるブドウと土着の生産の知恵を結びつけることで、ユニークな感覚体験を可能にするヴェネト州のワイン造り様式を信じています。"
                }
            },
            section2: {
                title: "イタリアワインの品質",
                paragraphs: {
                    1: "MonVinは現在、質の高い樽詰めワインの製造において万人が認めるリーダーであり、レストランが厳選した「ハウスワイン」に本物の価値を保証することで、その真の喜びを体現しています。",
                    2: "樽詰めワインの世界で積み重ねてきた素晴らしい経験により、MonVinは絶え間なく製品品質の向上を図るとともに、幅広いタイプのワインをチョイスしています。",
                    3: "MonVinは、より多くの人々を文化的かつ肯定的な価値観の世界に導くことを目指して、責任ある飲酒を促進しています。"
                }
            }
        },
        collection: {
            navigationTitle: 'あなたが好むパッケージのタイプを選択する',
            steel: 'スチール樽',
            keykeg: 'KeyKegs',
            availableWorldwide: '世界中でご利用いただける当社のコレクション',
            availableItaly: 'イタリアと日本のみでご利用いただける当社のコレクション'
        },
        beSmart: {
            title: "意識的な選択",
            section1: {
                title: "サプライチェーンのトレーサビリティ",
                advantage1: {
                    text: "百万リットル",
                    content: "MonVinは厳格なトレーサビリティプロジェクトを開発しました。このプロジェクトにより、グラスから醸造に至るまで、ワインの生産プロセス全体を遡って追跡することができます。"
                },
                advantage2: {
                    text: "人のエノロゴ（醸造家）",
                    content: "6人のエノロゴから成る技術スタッフが、生産と充填の各段階に常に携わっています。"
                },
                advantage3: {
                    text: "百万ユーロの技術投資",
                    content: "10年間以上にわたり技術革新に1千万ユーロを投資してきたMonVinでは、ワイン業界における重要な特許を保有しています。"
                },
            },
            section2: {
                title: "樽詰めワイン「スマートに、MonVinを飲む」",
                paragraphs: {
                    1: "樽詰めワインを飲むということは、環境問題に敏感な「スマートさ」を意味します。なぜなら、ボトルやパッケージを使用しないからです。",
                    2: "こうしてMonVinは、ワインテイスティングとより持続可能な消費を促進する、ワイン製造分野の新しい境界を開きます。",
                    3: "意識的な選択である樽詰めワインは、生産コストを抑え、エネルギーや環境資源の消費を少なくするとともに、廃棄物や大気汚染を減らすことができます。",
                    4: "これらすべてがMonVinの環境に対する配慮を物語っています。樽を選ぶことで、高品質のワインを味わう喜びを犠牲にすることなく、大幅な節約が実現できるのです。"
                },
                advantages: {
                    1: "ごみの削減",
                    2: "エコフレンドリー",
                    3: "環境に優しい",
                    4: "CO2排出量の削減"
                }
            },
            section3: {
                title: "100%クリーンエネルギー",
                text: "以下のエネルギーのみを使用しています"
            }
        },
        contact: {
            title: 'お問い合わせ',
            form: {
                title: 'こちらにご記入ください',
                firstName: '名',
                lastName: '姓',
                email: 'メールアドレス',
                message: 'メッセージ',
                privacyPolicy: "以下に記載されている個人データの取り扱いに同意します。",
                errors: {
                    empty: 'この 欄 は 必須です',
                    email: 'この 欄 には 有効な メール アドレスを ご記入ください。',
                    policy: '続行 する には プライバシー ポリシー を ご承諾 いただく 必要があります'
                },
                feedback: {
                    title: 'ありがとうございます！',
                    message: "メッセージをいただき、ありがとうございます。確かに受信しました。できるだけ早く返信いたします。"
                },
                cta: "Submit",
                subscribe: "Subscribe"
            }
        },
        package: {
            title: 'KeyKegs： 品質 と 保証',
            section1: {
                paragraphs: {
                    1: "MonVinは、リサイクルPETを50%以上使って作られた環境に優しい使い捨て樽を使用しています。これは「SlimKeg」によって開発された技術です。",
                    2: "特許取得済みのBag-in-Ballの原理は、ハイテクPET容器に入れられた特殊な内部バッグに基づいています。このバッグには、ラミネート加工を施したアルミニウムが使用されています。この2コンパートメントシステムが、SlimKeg内の飲料の品質を維持し、長持ちさせるのです。この樽が最適な保護となって空気にさらされることを避けるため、飲料がガスと接触することは一切なく、より長期の保存が可能となります。",
                    3: '便利な形と持ちやすいグリップを備えたSlimKegは、どなたでもすぐにお使いいただけます。 この樽は軽量で、簡単に積み重ねられます。つまり、SlimKegシステムなら、倉庫内と輸送時のスペースを節約できるのです。',
                    4: '一部のワインでは、次のモデルもご利用いただけます。',
                    5: '重量： 20 リットル、樽： 20 KG >   750mlのボトル27本分に相当'
                }
            },
            advantages: {
                1: '最高級の 品質',
                2: 'スティルワインおよびスパークリングワインに最適で、長期保存が可能',
                3: '大部分の再充填システムに適応',
                4: '高額の返却送料不要',
                5: "樽漏れやクリーニング費用なし、サーバーには圧縮空気を使用",
                6: '一部のワインでは、PoliKEGモデルもご利用いただけます。'
            },
            section2: {
                title: 'メリット',
                paragraphs: {
                    1: 'MonVinが使用している軽量樽はリサイクル可能です。',
                    2: '原材料はすべてわずか数ステップで分離でき、新しいSlimKegの製造に使用されます。',
                    3: '樽の基本的な構成要素自体、100%リサイクルされたプラスチックでできています。'
                }
            },
            section3: {
                paragraphs: {
                    1: "しかし、環境へのメリットは、それだけではありません。コンパクトなデザインのため、載積容量がスチール樽に比べて25〜30%大きくなります。",
                    2: "発送回数が少なくて済み、返却という概念がなくなります。輸送面での節約率は65%に達します。こうして削減されるCO2排出量は、樽から注ぐ際に圧縮空気を使用することで、さらに減少します。スチール樽の清掃に使用される有害な化学物質もなくなります。",
                    3: "SlimKegシステムは、多くの企業が掲げる持続可能性の目標と完全に一致している上、低コストながら品質を犠牲にしていません。"
                },
                advantages: {
                    1: 'もうボトルが入った重い箱を持ち上げる必要なし',
                    2: 'もうボトルを事前に冷やす必要なし',
                    3: 'もうボトルを1本1本開ける必要なし',
                    4: 'もうボトルを処分する必要なし'
                }
            }
        },
        steelkeg: {
            title: "スチール：品質と保証",
            section1: {
                paragraphs: {
                    1: "この樽に使用されているスチールは、光や、特に空気と接触することがないため、他のどんな素材よりもワインの保存に適しています。常に栓を抜いたばかりの新鮮なワインを飲んでいるように感じられます。",
                    2: "新たに充填する前に施される殺菌技術のおかげで、樽は再利用できます。こうして、ワインは味や香り、色などの点において、常に安全かつ保証されています。",
                    3: "MonVinの樽は人間工学に基づいて設計されており、運搬や積み替えが容易な上に、スペースをほとんど取りません。また独特な黒いコーティングがワインを熱衝撃から守り、代わりにスチールのみで覆われた樽が熱衝撃を吸収します。",
                    4: "重量：20リットル、ボトル20本分に相当"
                }
            },
            advantages: {
                1: "ワインとその特性を変えずに維持",
                2: "インストールが簡単",
                3: "カスタマイズ可能な光沢のある黒",
                4: "メンテナンス費用なし",
                5: "人間工学に基づいたデザインで輸送と積み重ねが容易",
                6: "再利用可能：すばやく殺菌",
            },
            section2: {
                title: "メリット",
                advantages: {
                    1: "ボトル取扱いの問題なし",
                    2: "事前に冷やす必要なし",
                    3: "ボトルを開ける必要なし",
                    4: "ボトル片付けの必要なし"
                }
            }
        }
    }
}